<template>

<b-row v-if="contenidoTabla.cifrasControl !== undefined && contenidoTabla.cifrasControl !== null" align-v="center" >
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-col cols="4" v-for="cifrasc in contenidoTabla.cifrasControl" :key="cifrasc.idEstatus">
        <font-awesome-icon v-if="cifrasc.icono !== undefined" :icon="cifrasc.icono" />
       <Strong> {{cifrasc.estatus}} : {{cifrasc.cifra}}  </Strong> 
    </b-col>
</b-row>
</template>

<script>
export default {
    name: "CifrasControl",
    props: {
        contenidoTabla: Object
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }),
    methods: {

    },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    mounted() {},
}
</script>
